import { render, staticRenderFns } from "./ValueOptionComputationSection.vue?vue&type=template&id=6e43bbae&"
import script from "./ValueOptionComputationSection.vue?vue&type=script&lang=ts&"
export * from "./ValueOptionComputationSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports